import { SettingsKeys } from "src/types/Settings.type";

export const initialSettingsConfig: SettingsKeys = {
  language: "en-US",
  currency: "EUR",
};
